export class PasswordValidator {

    public message: string = '';
    private currentPassword: string = '';
    private newPassword: string = '';
    private confirmPassword: string = '';

    constructor(currentPassword: string, newPassword: string, confirmPassword: string) {
        this.currentPassword = currentPassword;
        this.newPassword = newPassword;
        this.confirmPassword = confirmPassword;
    }

    public validate(): boolean {

        if (this.currentPassword == this.newPassword) {
            this.message = 'A nova senha deve ser diferente da anterior'
            return false;
        }

        if (this.newPassword.length < 6) {
            this.message = 'A nova senha deve ter 6 caracteres no mínimo'
            return false;
        }

        if (!(/.*[A-Z].*/.test(this.newPassword))) {
            this.message = 'A nova senha deve conter maiúsculas'
            return false;
        }
        
        if (!(/.*[a-z].*/.test(this.newPassword))) {
            this.message = 'A nova senha deve conter minúsculas'
            return false;
        }


        if (!(/.*[0-9].*/.test(this.newPassword))) {
            this.message = 'A nova senha deve conter números'
            return false;
        }

        if (!(/[$-/:-?{-~!"^_`\[\]]/.test(this.newPassword))) {
            this.message = 'A nova senha deve conter símbolos'
            return false;
        }

        if (this.newPassword != this.confirmPassword) {
            this.message = 'A nova senha e confirmação deve ser iguais'
            return false;
        }

        return true;
    }
}